/**
 * @file 搜索框
 * @author (v_lichaoqing)
 */
import Search from './Search.js';
export default Search;